import * as React from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

export interface SimpleDialogProps {
	titulo?: string;
	tituloBotao?: string;
	texto: string;
	open: boolean;
	onClose: () => void;
	onClick?: () => void;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
	props,
	ref
) {
	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function ToastAviso(props: SimpleDialogProps) {
	const { onClose, open, texto } = props;

	const handleClose = (
		event?: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		onClose();
	};

	return (
		<Stack spacing={2} sx={{ width: "100%" }}>
			<Snackbar
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				open={open}
				autoHideDuration={10000}
				onClose={handleClose}
			>
				<Alert
					onClose={handleClose}
					severity="warning"
					sx={{
						width: "100%",
						marginBottom: "20%",
						"& .MuiIconButton-root": {
							minWidth: "20px",
						}
					}}
				>
					<span style={{ whiteSpace: "pre-line" }}>{texto}</span>
				</Alert>
			</Snackbar>
		</Stack>
	);
}

export default ToastAviso;
